export default __webpack_public_path__ + "static/media/hr.b0df31d3.jpg";